module.exports = __webpack_public_path__ + "img/1546745980.3ed1b671.jpg";